import { jsx } from "react/jsx-runtime";
import React from "react";
var warning_triangle_default = (prefix = "") => {
  return [
    /* @__PURE__ */ jsx("path", { d: "M11.0036 14.2499h2v-6h-2v6zm1 1.5c-.6904 0-1.25.5596-1.25 1.25 0 .6903.5596 1.25 1.25 1.25.6903 0 1.25-.5597 1.25-1.25 0-.6904-.5597-1.25-1.25-1.25z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m1.1152 20.5341 10-19h1.7699l10 19-.8849 1.4658h-20l-.885-1.4658zm2.5413-.5342h16.6873l-8.3436-15.853L3.6565 20z"
      }
    )
  ];
};
export {
  warning_triangle_default as default
};
